/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ArtifactCI } from '../models/artifact-ci';
import { BulkWorkflowAttachRequest } from '../models/bulk-workflow-attach-request';
import { CiArtifactResponse } from '../models/ci-artifact-response';

/**
 * Ui Artifact Ci Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiArtifactCiControllerService extends __BaseService {
  static readonly getAllArtifactsCIUsingGETPath = '/cc-ui/v1/artifacts-ci';
  static readonly createArtifactCIUsingPOSTPath = '/cc-ui/v1/artifacts-ci';
  static readonly getArtifactCisByStackUsingGETPath =
    '/cc-ui/v1/artifacts-ci/blueprint/{stackName}';
  static readonly bulkEditWorkflowUsingPOSTPath =
    '/cc-ui/v1/artifacts-ci/bulk-edit-workflow';
  static readonly getArtifactCiByNameUsingGETPath =
    '/cc-ui/v1/artifacts-ci/name/{ciName}';
  static readonly getArtifactCIUsingGETPath = '/cc-ui/v1/artifacts-ci/{ciId}';
  static readonly updateArtifactCIUsingPUTPath =
    '/cc-ui/v1/artifacts-ci/{ciId}';
  static readonly deleteArtifactCIUsingDELETEPath =
    '/cc-ui/v1/artifacts-ci/{ciId}';
  static readonly getArtifactsForCIUsingGETPath =
    '/cc-ui/v1/artifacts-ci/{ciName}/artifacts';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllArtifactsCI
   * @return OK
   */
  getAllArtifactsCIUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<ArtifactCI>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifacts-ci`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ArtifactCI>>;
      }),
    );
  }
  /**
   * getAllArtifactsCI
   * @return OK
   */
  getAllArtifactsCIUsingGET(): __Observable<Array<ArtifactCI>> {
    return this.getAllArtifactsCIUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<ArtifactCI>),
    );
  }

  /**
   * createArtifactCI
   * @param artifactCI artifactCI
   * @return OK
   */
  createArtifactCIUsingPOSTResponse(
    artifactCI: ArtifactCI,
  ): __Observable<__StrictHttpResponse<ArtifactCI>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = artifactCI;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts-ci`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactCI>;
      }),
    );
  }
  /**
   * createArtifactCI
   * @param artifactCI artifactCI
   * @return OK
   */
  createArtifactCIUsingPOST(artifactCI: ArtifactCI): __Observable<ArtifactCI> {
    return this.createArtifactCIUsingPOSTResponse(artifactCI).pipe(
      __map((_r) => _r.body as ArtifactCI),
    );
  }

  /**
   * getArtifactCisByStack
   * @param stackName stackName
   * @return OK
   */
  getArtifactCisByStackUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<ArtifactCI>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts-ci/blueprint/${encodeURIComponent(
          String(stackName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ArtifactCI>>;
      }),
    );
  }
  /**
   * getArtifactCisByStack
   * @param stackName stackName
   * @return OK
   */
  getArtifactCisByStackUsingGET(
    stackName: string,
  ): __Observable<Array<ArtifactCI>> {
    return this.getArtifactCisByStackUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<ArtifactCI>),
    );
  }

  /**
   * bulkEditWorkflow
   * @param bulkWorkflowAttachRequest bulkWorkflowAttachRequest
   */
  bulkEditWorkflowUsingPOSTResponse(
    bulkWorkflowAttachRequest: BulkWorkflowAttachRequest,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = bulkWorkflowAttachRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/artifacts-ci/bulk-edit-workflow`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * bulkEditWorkflow
   * @param bulkWorkflowAttachRequest bulkWorkflowAttachRequest
   */
  bulkEditWorkflowUsingPOST(
    bulkWorkflowAttachRequest: BulkWorkflowAttachRequest,
  ): __Observable<null> {
    return this.bulkEditWorkflowUsingPOSTResponse(
      bulkWorkflowAttachRequest,
    ).pipe(__map((_r) => _r.body as null));
  }

  /**
   * getArtifactCiByName
   * @param ciName ciName
   * @return OK
   */
  getArtifactCiByNameUsingGETResponse(
    ciName: string,
  ): __Observable<__StrictHttpResponse<ArtifactCI>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts-ci/name/${encodeURIComponent(String(ciName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactCI>;
      }),
    );
  }
  /**
   * getArtifactCiByName
   * @param ciName ciName
   * @return OK
   */
  getArtifactCiByNameUsingGET(ciName: string): __Observable<ArtifactCI> {
    return this.getArtifactCiByNameUsingGETResponse(ciName).pipe(
      __map((_r) => _r.body as ArtifactCI),
    );
  }

  /**
   * getArtifactCI
   * @param ciId ciId
   * @return OK
   */
  getArtifactCIUsingGETResponse(
    ciId: string,
  ): __Observable<__StrictHttpResponse<ArtifactCI>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts-ci/${encodeURIComponent(String(ciId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactCI>;
      }),
    );
  }
  /**
   * getArtifactCI
   * @param ciId ciId
   * @return OK
   */
  getArtifactCIUsingGET(ciId: string): __Observable<ArtifactCI> {
    return this.getArtifactCIUsingGETResponse(ciId).pipe(
      __map((_r) => _r.body as ArtifactCI),
    );
  }

  /**
   * updateArtifactCI
   * @param params The `UiArtifactCiControllerService.UpdateArtifactCIUsingPUTParams` containing the following parameters:
   *
   * - `ciId`: ciId
   *
   * - `artifactCI`: artifactCI
   *
   * @return OK
   */
  updateArtifactCIUsingPUTResponse(
    params: UiArtifactCiControllerService.UpdateArtifactCIUsingPUTParams,
  ): __Observable<__StrictHttpResponse<ArtifactCI>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.artifactCI;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/artifacts-ci/${encodeURIComponent(String(params.ciId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactCI>;
      }),
    );
  }
  /**
   * updateArtifactCI
   * @param params The `UiArtifactCiControllerService.UpdateArtifactCIUsingPUTParams` containing the following parameters:
   *
   * - `ciId`: ciId
   *
   * - `artifactCI`: artifactCI
   *
   * @return OK
   */
  updateArtifactCIUsingPUT(
    params: UiArtifactCiControllerService.UpdateArtifactCIUsingPUTParams,
  ): __Observable<ArtifactCI> {
    return this.updateArtifactCIUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as ArtifactCI),
    );
  }

  /**
   * deleteArtifactCI
   * @param ciId ciId
   * @return OK
   */
  deleteArtifactCIUsingDELETEResponse(
    ciId: string,
  ): __Observable<__StrictHttpResponse<ArtifactCI>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/artifacts-ci/${encodeURIComponent(String(ciId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ArtifactCI>;
      }),
    );
  }
  /**
   * deleteArtifactCI
   * @param ciId ciId
   * @return OK
   */
  deleteArtifactCIUsingDELETE(ciId: string): __Observable<ArtifactCI> {
    return this.deleteArtifactCIUsingDELETEResponse(ciId).pipe(
      __map((_r) => _r.body as ArtifactCI),
    );
  }

  /**
   * getArtifactsForCI
   * @param ciName ciName
   * @return OK
   */
  getArtifactsForCIUsingGETResponse(
    ciName: string,
  ): __Observable<__StrictHttpResponse<Array<CiArtifactResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifacts-ci/${encodeURIComponent(
          String(ciName),
        )}/artifacts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CiArtifactResponse>>;
      }),
    );
  }
  /**
   * getArtifactsForCI
   * @param ciName ciName
   * @return OK
   */
  getArtifactsForCIUsingGET(
    ciName: string,
  ): __Observable<Array<CiArtifactResponse>> {
    return this.getArtifactsForCIUsingGETResponse(ciName).pipe(
      __map((_r) => _r.body as Array<CiArtifactResponse>),
    );
  }
}

module UiArtifactCiControllerService {
  /**
   * Parameters for updateArtifactCIUsingPUT
   */
  export interface UpdateArtifactCIUsingPUTParams {
    /**
     * ciId
     */
    ciId: string;

    /**
     * artifactCI
     */
    artifactCI: ArtifactCI;
  }
}

export { UiArtifactCiControllerService };
